import React from "react"
import classnames from "classnames"
import styles from "./InputCheckBox.less"
import CheckIcon from "../Icons/CheckIcon"

class InputCheckBox extends React.PureComponent {
  constructor(props){
    super(props)

    // for testing purposes
    if (process && process.env && process.env.NODE_ENV === 'test'){
      this.random = 1
    }else {
      this.random = Math.random()
    }
  }
  componentDidMount() {
    const { checked, onChange = () => { } } = this.props
    if (checked) {
      this._onChange(checked, true)
    }
  }

  _onBlurHandler = () => {
    const { onBlur = () => { }, onChange = () => { } } = this.props
    onBlur()
    if (this.input){
      onChange(this.input.checked)
    }
  }

  _onChangeHandler = (event) => {
    this._onChange(event.target.checked)
  }

  _onChange = (value, forceChange = false) => {
    const { onChange = () => { } } = this.props
    this._dirtyClass(value)
    onChange(value)
    if (forceChange && this.input) {
      this.input.checked = value
    }
  }

  _dirtyClass = (value) => {
    if (this.label){
      if (value && value != "") {
        this.label.classList.add(styles.LabelCheckBoxWithValue)
      } else {
        this.label.classList.remove(styles.LabelCheckBoxWithValue)
      }
    }
  }

  _getThisInput = () => {
    const { getThisInput = () => { } } = this.props
    getThisInput(this)
  }

  render() {
    const {
      name = "",
      type = "text",
      label = "",
      styleName = "light",
      large = false,
      required = false,
      disabled = false,
      message = "",
      isValid = true
    } = this.props
    return (
      <div
        getthisinput={this._getThisInput()}
        className={classnames({
          [styles.InputCheckBox]: true,
          [styles.InputCheckBoxLarge]: large
        })}>
        <input
          ref={c => this.input = c}
          className={classnames({
            [styles.InputCheckBoxInput]: true
          })}
          name={`${name}`}
          id={`${name}-${this.random}`}
          type={"checkbox"}
          disabled={disabled}
          onBlur={this._onBlurHandler}
          onChange={this._onChangeHandler}
        />
        <label
          ref={c => this.label = c}
          htmlFor={`${name}-${this.random}`}
          className={classnames({
            [styles.LabelCheckBox]: true,
            [styles.LabelCheckBoxWithValue]: false
        })}>
          <CheckIcon style={{
            width: "10px",
            padding: "3px"
          }}/>
        </label>
        <label
          htmlFor={`${name}-${this.random}`}
          className={classnames({
            [styles.Label]: true
          })}>
          {label}
          {required &&
              <span className={classnames({
                [styles.requiredStar]: true
              })}>*</span>
          }
        </label>
        <div className={classnames({
          [styles.message]: true,
          [styles.messageShow]: !isValid
        })}>
          {message}
        </div>
      </div>
    )
  }
}


export default InputCheckBox



// WEBPACK FOOTER //
// ./src/AtomicComponents/InputCheckBox/InputCheckBox.jsx